import React, { Component } from "react";
import NavBar from "../components/NavBar";
import Sidebar from "./components/Sidebar";
import ServiceGallery from "./components/ServiceGallery"
import Footer from "../components/Footer";
import MobileMenu from "../components/MobileMenu";
class SportsProgramDevelopment extends Component {
  render() {
    return (
      <div>
        {/* Navigation bar */}
        <NavBar />

        {/* breadcrumb */}
        {/*====================  breadcrumb area ====================*/}
        <div
          className="breadcrumb-area breadcrumb-bg"
          style={{
            backgroundImage: `url(assets/img/backgrounds/funfact-bg.jpg)`
          }}
        >
          <div className="container">
            <div className="row">
              <div className="col">
                <div className="page-banner text-center">
                  <h1>Sports Program for Development</h1>
                  <ul className="page-breadcrumb">
                    <li>
                      <a href="/">Home</a>
                    </li>
                    <li>
                      <a href={`${process.env.PUBLIC_URL}/services`}>
                        Services
                      </a>
                    </li>
                    <li>Sports Program for Development</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/*====================  End of breadcrumb area  ====================*/}

        <div className="page-wrapper section-space--inner--120">
          {/*Service section start*/}
          <div className="service-section">
            <div className="container">
              <div className="row">
                <div className="col-lg-8 col-12 order-1 order-lg-2">
                  <div className="service-details">
                    {/* service gallery */}
                    <ServiceGallery />

                    <div className="content section-space--top--30">
                      <h2>Sports Program for Development</h2>

                      <p>
                        Sports play a vital role in a child’s overall growth and development.
                        Beyond improving physical fitness, participation in sports helps children
                        build confidence, develop discipline, strengthen social skills,
                        and learn valuable life lessons. Our Sports Program for Development
                        is designed to provide children with opportunities to participate
                        in structured physical activities that support their physical,
                        cognitive, emotional, and social well-being in a fun, safe, and
                        inclusive environment.
                      </p>

                      <p>
                        The program encourages children to develop essential motor skills
                        such as balance, coordination, agility, strength, flexibility,
                        and endurance through age-appropriate sports and recreational
                        activities. Regular participation in physical activities also
                        enhances concentration, decision-making, problem-solving, and
                        self-regulation, contributing positively to both academic performance
                        and everyday functioning.
                      </p>

                      <h3 className="section-space--top--50">How Our Sports Program Helps</h3>

                      <p>
                        Children learn the importance of teamwork, communication, leadership,
                        responsibility, respect, and sportsmanship while participating
                        in individual and group activities. These experiences help
                        them build meaningful relationships, improve self-esteem,
                        and develop resilience by learning how to face challenges,
                        celebrate achievements, and cope with success and setbacks
                        in a positive manner.
                      </p>
                      <p>
                        Our Sports Program is inclusive and adaptable to meet the needs
                        of children with diverse abilities, including those with
                        developmental delays, autism spectrum disorder, ADHD,
                        learning disabilities, and other special needs.
                        Activities are carefully planned to encourage participation,
                        enjoyment, and personal achievement while ensuring that every
                        child feels valued and supported. Parents and caregivers are
                        encouraged to be active partners in celebrating progress and
                        promoting healthy lifestyles beyond the program.
                      </p>

                      <h3 className="section-space--top--50">Conclusion</h3>
                      <p>
                        At Shakuntla Learn and Fly Foundation, we believe that sports are
                        a powerful tool for building healthy bodies, confident minds, and
                        strong character. Through our Sports Program for Development,
                        we inspire children to stay active, develop essential life skills,
                        and discover their potential in a supportive and encouraging
                        environment. By combining physical activity with personal growth,
                        we help children build the confidence, resilience, and teamwork
                        skills needed to thrive in every aspect of life.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 col-12 order-2 order-lg-1">
                  <Sidebar />
                </div>
              </div>
            </div>
          </div>
          {/*Service section end*/}
        </div>

        {/* Footer */}
        <Footer />

        {/* Mobile Menu */}
        <MobileMenu />
      </div>
    );
  }
}

export default SportsProgramDevelopment;
